import { type LocationAttribute } from '@src/lib/__generated/vetspire/sdk';

const scheduleTypeAttributeName = 'Schedule Type';

export enum scheduleTypeOptions {
	closed = 'Closed',
	open = 'Open',
	hybrid = 'Hybrid',
}

/**
 * NOTE: reference https://aspendent.atlassian.net/browse/DCP-3875 for
 * documentation on how schedule type options align to business logic.
 *
 * NOTE: After working with the business it is looking like "hybrid" schedule
 * type will be handled within the schedule itself.  The plan is this app only
 * will need to worry about "Open" || "Closed". "Hybrid" will be removed from
 * the options if the plan succeeds.
 */
export default function DetermineScheduleType(attributes: LocationAttribute[]) {
	const ScheduleTypeObject = attributes.find(
		(attribute) => attribute?.customAttribute?.name === scheduleTypeAttributeName
	);

	if (!ScheduleTypeObject) {
		console.error(`no value provided for "${scheduleTypeAttributeName}"`);
		return scheduleTypeOptions.closed;
	}

	const { value } = ScheduleTypeObject;

	switch (value) {
		case scheduleTypeOptions.closed:
			return scheduleTypeOptions.closed;
		case scheduleTypeOptions.open:
			return scheduleTypeOptions.open;
		case scheduleTypeOptions.hybrid:
			return scheduleTypeOptions.hybrid;
		default:
			console.error(`invalid value for "${scheduleTypeAttributeName}" : ${value}`);
			return scheduleTypeOptions.closed;
	}
}
